<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              `${this.$t("gallery.edit.title")}`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("gallery.edit.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
               <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" class="">
                  <input
                    type="file"
                    name="profile_pic"
                    @change="changeFile($event)"
                    ref="profile_pic"
                    hidden
                  />
                  <v-badge bordered bottom overlap offset-x="20" offset-y="20">
                    <template v-slot:badge>
                      <v-icon
                        small
                        dark
                        @click="openFileExplorer"
                        class="edit-icon"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <v-avatar
                      size="120"
                      v-if="gallery.picture_url != null"
                      class="cursor-pointer imagePreviewWrapper"
                      @click="openFileExplorer"
                    >
                      <img
                        :src="API_BASE_URL + '/uploads/' + gallery.picture_url"
                        :alt="gallery.picture_url"
                        v-if="!previewImage"
                      />
                      <img
                        :src="previewImage"
                        :alt="gallery.picture_url"
                        v-if="previewImage"
                      />
                    </v-avatar>
                    <v-avatar
                      v-if="gallery.picture_url == null"
                      color="secondary"
                      class="white--text cursor-pointer imagePreviewWrapper"
                      :style="{ 'background-image': `url(${previewImage})` }"
                      size="120"
                      @click="openFileExplorer"
                    >
                    </v-avatar>
                  </v-badge>
                </v-col>
              </v-row>
              <span :class="`${serverSideErrors.picture ? 'red--text' : 'grey--text'} mb-3`">
                {{ serverSideErrors.picture ? serverSideErrors.picture : "Only jpg, png, gif are allowed" }}
              </span>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="gallery.title"
                    name="title"
                    label="Title"
                    rows="2"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                      serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-file-input
                    v-model="gallery.documents"
                    dense
                    label="Gallery Document"
                    prepend-icon="mdi-camera"
                    multiple
                    :error="serverSideErrors.documents != null"
                    :error-messages="serverSideErrors.documents"
                    ><template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template></v-file-input
                  >
                </v-col>
              </v-row> -->
              <!-- <v-row>
                <v-col
                  v-for="item in added_documents"
                  :key="item.document_url"
                  class="d-flex child-flex"
                  cols="2"
                >
                  <v-card>
                    <v-img
                      v-if="item.file_type == 'image'"
                      :src="API_BASE_URL + '/uploads/' + item.document_url"
                      :lazy-src="API_BASE_URL + '/uploads/' + item.document_url"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      :src="API_BASE_URL + '/default-video.jpg'"
                      :lazy-src="API_BASE_URL + '/default-video.jpg'"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-btn
                      icon
                      color="secondary"
                      name="delete_gallery"
                      title="Edit Gallery"
                      @click="confirmDelete(item.id)"
                    >
                      <v-icon small> mdi-close </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="secondary"
                      name="view_gallery"
                      title="Edit "
                      @click="imgClick(item)"
                      style="float: right"
                    >
                      <v-icon small v-if="item.file_type == 'image'">
                        mdi-eye</v-icon
                      >
                      <v-icon small v-else> mdi-eye</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row> -->
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveGalleryDetail"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-dialog v-model="imageDialog" max-width="100vh">
        <v-card>
          <v-btn
            icon
            color="secondary"
            name="delete_Gallery"
            title="Edit Gallery"
            @click="imageDialog = false"
            style="float: right"
          >
            <v-icon small> mdi-close </v-icon>
          </v-btn>
          <v-card-title class="text-h5 grey lighten-2">
            <v-img
              :src="API_BASE_URL + '/uploads/' + image_url"
              :lazy-src="API_BASE_URL + '/uploads/' + image_url"
              aspect-ratio="1"
              class="grey lighten-2"
            ></v-img>
          </v-card-title>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDocument(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";

// import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      gallery: {
        title: "",
        documents: [],
      },
      added_documents: [],
      delete_id: "",
      deleteDialog: false,
      imageDialog: false,
      image_url: "",
      base_url: process.env.VUE_APP_API_URL,
      profile_pic: {},
      previewImage: null,
    };
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),
    removeAllFiles() {
      this.$refs.dropzone.removeAllFiles();
    },
    saveGalleryDetail() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("title", this.gallery.title);
          formData.append("picture", this.profile_pic); 
          for (let i = 0; i < this.gallery.documents.length; i++) {
            formData.append("documents[]", this.gallery.documents[i]);
          }

          _self.$axios
            .put("/societyadmin/gallery/" + this.gallery.id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });

                _self.$router.push({ path: "/societyadmin/gallery" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    getGalleryDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/gallery/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;

          console.log(data);
          if (data.status) {
            _self.gallery = data.gallery;
             this.gallery.documents.map((x) => {
              x.name = x.document_url.replace("notice_documents/", "");
            });
            console.log("documne", this.gallery.documents);
            _self.added_documents = data.gallery.documents;

            console.log(_self.added_documents);
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    deleteDocument(Id) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/gallery/documents/" + Id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            console.log(data.status);
            this.getGalleryDetail();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
   openFileExplorer() {
      this.$refs.profile_pic.click();
    },
    changeFile(e) {
      this.profile_pic = e.target.files[0];
      let input = this.$refs.profile_pic;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    closeDialog() {
      (this.deleteDialog = false), (this.delete_id = "");
    },
    imgClick(item) {
      // if (item.file_type == "image") {
      //   this.image_url = item.document_url;
      //   this.imageDialog = true;
      // } else {
        window.open(`${this.base_url}/uploads/${item.document_url}`, "_blank");
      // }
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getGalleryDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>